/**
 * Ekya Premium — performance + desktop nav layout
 */
(function () {
  'use strict';

  if (!document.body.classList.contains('ekya-premium')) return;

  function initImagePerformance() {
    if (!('IntersectionObserver' in window)) return;

    const imageObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const img = entry.target;
          if (img.dataset.src && !img.src) {
            img.src = img.dataset.src;
          }
          if (img.decode) {
            img.decode().catch(() => {});
          }
          imageObserver.unobserve(img);
        });
      },
      { rootMargin: '200px' }
    );

    document.querySelectorAll('.product-grid img[loading="lazy"], .card-gallery img[loading="lazy"]').forEach((img) => {
      imageObserver.observe(img);
    });
  }

  function initCLSPrevention() {
    document.querySelectorAll('.card-gallery').forEach((gallery) => {
      if (!gallery.style.aspectRatio) {
        gallery.style.aspectRatio = '4 / 5';
      }
    });
  }

  function initDesktopNav() {
    const header = document.querySelector('header-component');
    const headerGroup = document.querySelector('#header-group');
    if (!header) return;

    const desktop = window.matchMedia('(min-width: 990px)');
    const apply = () => {
      if (desktop.matches) header.dataset.menuStyle = 'menu';
    };

    apply();
    desktop.addEventListener('change', apply);

    if (typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(apply);
      observer.observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
    }

    if (!headerGroup) return;

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        headerGroup.classList.toggle('ekya-header-group--scrolled', window.scrollY > 6);
        ticking = false;
      });
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    initDesktopNav();
    initImagePerformance();
    initCLSPrevention();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
